import { render, staticRenderFns } from "./MensagensRapidas.vue?vue&type=template&id=aaedb51a&scoped=true"
import script from "./MensagensRapidas.vue?vue&type=script&lang=js"
export * from "./MensagensRapidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaedb51a",
  null
  
)

export default component.exports